export function findNearestElementMatchingTags(el, tagNames) {
  if (!el || !tagNames) {
    return null;
  }

  const lowerCaseTags = tagNames.map(t => t.toLowerCase());

  if (el.tagName && lowerCaseTags.indexOf(el.tagName.toLowerCase()) !== -1) {
    return el;
  } else if (el.parentNode) {
    return findNearestElementMatchingTags(el.parentNode, tagNames);
  }

  return null;
}

export function findNearestElementMatchingAttribute(
  el,
  attributeName,
  attributeValue
) {
  if (!el || !attributeName || !attributeValue) {
    return null;
  }

  if (el.getAttribute(attributeName) === attributeValue) {
    return el;
  } else if (el.parentNode) {
    return findNearestElementMatchingAttribute(
      el.parentNode,
      attributeName,
      attributeValue
    );
  }
  return null;
}

export function contains(outer, inner) {
  return outer && inner instanceof Node && outer.contains(inner);
}

export function loadScript({ src, onLoad, onError }) {
  const script = document.createElement('script');
  script.src = src;
  script.type = 'text/javascript';
  script.onload = onLoad;
  script.onerror = onError;
  const head = document.getElementsByTagName('head')[0];
  head.appendChild(script);
}

export function loadScriptPromise(src) {
  return new Promise((resolve, reject) => {
    loadScript({
      src,
      onLoad: () => resolve(),
      onError: () => reject(),
    });
  });
}

export function loadScripts(...src) {
  return src.reduce((acc, cv) => {
    return acc.then(() => loadScriptPromise(cv));
  }, Promise.resolve());
}

// TODO: Currently only handles X
function findNearestScrollParent(node) {
  function isScrollable(el) {
    return getComputedStyle(el)['overflow-x'] === 'auto';
  }

  if (isScrollable(node)) {
    return node;
  } else if (node.parentElement) {
    return findNearestScrollParent(node.parentElement);
  }
  return null;
}

/**
 * Make sure the given child element is fully visible in it's scrollable
 * parent. If it's not, put it all the way to the left.
 * element.scrollIntoView can overscroll and look bad in IE11
 * TODO: Currently only handles X
 */
export function scrollIntoView(node) {
  if (!node) {
    return;
  }

  const parent = findNearestScrollParent(node);
  if (parent) {
    const width = parent.offsetWidth;
    const scrollX = parent.scrollLeft;
    const itemX = node.offsetLeft;
    const itemWidth = node.offsetWidth;
    if (itemX < scrollX || itemX + itemWidth > scrollX + width) {
      parent.scrollLeft = node.offsetLeft;
    }
  }
}

export function isVisible(el) {
  if (!el) {
    return false;
  }

  const style = window.getComputedStyle(el);
  return (
    style.display !== 'none' &&
    style.visibility !== 'hidden' &&
    style.opacity !== '0' &&
    (el.parentElement ? isVisible(el.parentElement) : true)
  );
}

export function isOpaque(el) {
  if (!el) {
    return false;
  }

  const style = window.getComputedStyle(el);
  return (
    style.opacity === '1' &&
    (el.parentElement ? isOpaque(el.parentElement) : true)
  );
}

export function isOnScreen(el) {
  if (!el) {
    return false;
  }

  const rect = el.getBoundingClientRect();
  return (
    rect.left + rect.width > 0 &&
    rect.left < window.innerWidth &&
    rect.top + rect.height > 0 &&
    rect.top < window.innerHeight
  );
}

// https://gomakethings.com/how-to-get-the-first-and-last-focusable-elements-in-the-dom/
export function getFirstFocusableElement(node) {
  const focusable = node.querySelectorAll(
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
  );
  if (focusable.length > 0) {
    return focusable[0];
  }
  return null;
}

// https://stackoverflow.com/questions/3485365/how-can-i-force-webkit-to-redraw-repaint-to-propagate-style-changes
export function forceRedraw(el) {
  if (el) {
    const current = el.style.display;
    el.style.display = 'none';
    // eslint-disable-next-line no-unused-vars
    const h = el.offsetHeight;
    el.style.display = current;
  }
}

/**
 * NodeList does not support things like map, so you may want
 * to convert it to an array
 */
export function nodeListToArray(list) {
  const items = [];
  for (let i = 0; i < list.length; i++) {
    items.push(list[i]);
  }
  return items;
}



// WEBPACK FOOTER //
// ./src/app/utils/dom.js